<template>
  <div>
    <div class="router-header flex flex-wrap items-center mb-3 mb-base">
      <div
        class="content-area__heading pr-4"
      >
        <!--<h4 class="mb-2">Let's Start</h4>-->
        <div class="mt-2 mb-1">
          <span style="font-size: 25px;">{{statement}}</span>
        </div>
      </div>
    </div>

    <div class="items-center">
      <ThreeStepToggle :q="q" />
      <!--<vs-button type="border" @click="progress(0)">Yes</vs-button>
      <vs-button type="border" @click="progress(1)">Partly</vs-button>
      <vs-button type="border" @click="progress(2)">No</vs-button>
      <vs-button type="border" @click="progress(3)">Not Sure</vs-button>-->
    </div>
  </div>
</template>

<script>
import ThreeStepToggle from './ThreeStepToggle'
export default {
  name: "QuestionOne",
  components: {ThreeStepToggle},
  props: ["statement", "q"],
  data() {
    return {
      answerOne: null,
      answers: ["YES", "PARTLY", "NO"],
      btnType: "filled"
    };
  },
  methods: {
    progress(i) {
      let value = 100;
      if (i === 0) value = 100;
      else if (i === 1) value = 50;
      else if (i === 2) value = 0;
      else if (i === 3) value = 25;
      const progressObj = {
        q: this.q,
        value
      }
      this.$store
        .dispatch("competencyProgress/calculate", progressObj)
        .then(res => {
          console.log("progress calculate", res);
          console.log(this.$store.state.competencyProgress);
        })
        .catch(err => {
          console.log("error progress calculate", err);
        });
    }
  }
};
</script>

<style scoped>
.borderWhite2 {
  border: 2px solid white;
}

.borderPrimary2 {
  border-color: #9dcd5b;
}

.vx-card .vx-card__collapsible-content {
  -webkit-transition: none !important;
  transition: none !important;
}

.selectedAnswer {
  background: #9dcd5b! important;
  color: white! important;
}

.items-center {
  text-align: center;
  text-align: -moz-center;
  text-align: -webkit-center;
}
</style>
